import { useIdleTimer } from 'react-idle-timer';
export default useIdleTimer;
//# sourceMappingURL=idle.web.js.map